<template>
  <component :is="isMobile ? 'mobile-navi' : 'desktop-navi'" v-bind="$props" />
</template>

<script>
import DesktopNavi from './desktop/DesktopNavi'
import MobileNavi from './mobile/MobileNavi'

export default {
  name: 'Navigation',

  components: {
    DesktopNavi,
    MobileNavi,
  },

  props: {
    showBasket: Boolean,

    level1Links: {
      type: Array,
      required: true,
    },

    level2Links: {
      type: Array,
      default: () => [],
    },

    level2CallToAction: {
      type: Object,
      default: () => null,
    },

    logoHref: {
      type: String,
      default: 'https://sanitas.com',
    },

    loginLinks: {
      type: Object,
      default: () => null,
    },

    secondaryLinks: {
      type: Array,
      default: () => [],
    },

    languages: {
      type: Array,
      default: () => [],
    },

    search: {
      type: Object,
      default: () => {
        return {
          label: undefined,
          url: undefined,
        }
      },
    },
  },
  data() {
    return {
      wasMobileBefore: undefined,
    }
  },
  computed: {
    isMobile() {
      return !this.$mq['lg!']
    },
  },
  watch: {
    isMobile() {
      /* TODO: The widget rerendering needs to be possible and we need to rerender it at mobile / desktop switch */
      /* Because of switching between the MobileNavi and DesktopNavi components in the template we have an issue
      with the basket widget. To temporarily fix it we reload the page at mobile / desktop switch. */
      if (
        this.wasMobileBefore !== undefined &&
        this.isMobile !== this.wasMobileBefore
      ) {
        window.location.reload()
      }
    },
  },
  mounted() {
    this.wasMobileBefore = !this.$mq['lg!']
  },
}
</script>
